import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Request from "core/requests";
import { Loading } from "components/common";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import ErrorCardcomponent from "components/common/card/ErrorCard.component";
import SelectZoneAndStationCard from "components/cards/select/SelectZoneAndStation.component";
import CurrentMetricDataContainer from "containers/currentData/CurrentMetricData.container";
import SelectDateStartAndEndComponent from "components/cards/select/SelectDateStartAndEnd.component";
import CardAutocompleteComponent from "components/autocomplete/CardAutocomplete.component";
import { saveMetric, saveCluster, saveStationID } from "store/user.store";
import { DateTime } from "luxon";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { optionsMetrics } from "constants/metrics";
import { refreshToken, logout } from "store/user.store";
import { openSnackbar } from "store/slices/snackbar";
import { useTranslation } from "react-i18next";
import MetricRenderContainer from "./MetricRender.container";
import StatsMetricContainer from "./containers/statsMetric/StatsMetric.container";
import { getTimeZoneLondon } from "utils/timezone";
import TitleSectionComponent from "components/cards/title/TitleSection.component";

const MetricsEnvironmentContainer = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const {
    token,
    cluster,
    stationID,
    metric: metricStore,
    refresh_token,
    user,
  } = useSelector((state) => state.user);

  const [dataStations, setDataStations] = useState(null);

  const [metric, setMetric] = useState(
    metricStore ? metricStore : optionsMetrics[0]
  );
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [dataDouble, setDataDouble] = useState(null);
  const [listClusters, setListClusters] = useState([]);
  const [listStationsId, setListStationsId] = useState([]);
  const [zoneSelected, setZoneSelected] = useState(cluster ? cluster : []);
  const [stationIdSelected, setStationIdSelected] = useState(stationID);
  const [valueData, setValueData] = useState("24h");
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [hasTwoMetrics, setHasTwoMetrics] = useState(null);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [viewBarChart, setViewBarChart] = useState(true);

  const onRefresh = useCallback(() => {
    setRefresh(true);
  }, []);

  const handleChangeStationIdSelected = useCallback((item) => {
    setStationIdSelected(item);
    dispatch(saveStationID(item));
    setData(null);
    // eslint-disable-next-line
  }, []);

  const handleChange = useCallback((item) => {
    setLoading(true);
    setData(null);
    setDataDouble(null);
    setMetric(item);
    if (
      item.name === "wind_speed,wind_dir_idx" ||
      item.name === "rain_intensity,rain_intensity_peak" ||
      item.name === "pm10,pm2_5"
    ) {
      setHasTwoMetrics(true);
    } else {
      setHasTwoMetrics(false);
    }

    dispatch(saveMetric(item));
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(
    (resp, set) => {
      set(resp);
      setLoading(false);
      setIsFirstRefresh(true);
    },
    // eslint-disable-next-line
    []
  );

  const onChangeDateStart = useCallback(
    (item) => {
      setDateStart(item);
      if (dateEnd === null && item === null) {
        setValueData("24h");
      } else {
        setValueData("");
      }
      setData(null);
    },
    // eslint-disable-next-line
    [dateEnd]
  );

  const onChangeValueDate = useCallback((item) => {
    setValueData(item);
    setDateStart(null);
    setDateEnd(null);
    setData(null);
    // eslint-disable-next-line
  }, []);

  const onChangeDateEnd = useCallback(
    (item) => {
      setDateEnd(item);
      if (dateStart === null && item === null) {
        setValueData("24h");
      } else {
        setValueData("");
      }
      setData(null);
    },
    // eslint-disable-next-line
    [dateStart]
  );

  const onDownload = useCallback(() => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let datePath = null;
    let path = null;
    if (
      dateStart &&
      DateTime.fromISO(dateStart).isValid &&
      dateEnd &&
      DateTime.fromISO(dateEnd).isValid
    ) {
      //data di inzio e fine
      const start = getTimeZoneLondon(
        new DateTime(dateStart).toFormat("yyyy-MM-dd'T'HH:mm:ss")
      );
      const end = getTimeZoneLondon(
        new DateTime(dateEnd).toFormat("yyyy-MM-dd'T'HH:mm:ss")
      );
      datePath = `${new DateTime(dateStart).toFormat(
        "yyyy-MM-dd'T'HH:mm:ss"
      )}_00+00_${new DateTime(dateEnd).toFormat(
        "yyyy-MM-dd'T'HH:mm:ss"
      )}_00+00`;

      path =
        zoneSelected && !_.isEmpty(zoneSelected)
          ? `&cluster${zoneSelected}&datetime_start=${start}&datetime_end=${end}`
          : `&datetime_start=${start}&datetime_end=${end}`;
    } else {
      if (dateStart && DateTime.fromISO(dateStart).isValid) {
        //data di inzio e fine
        const start = getTimeZoneLondon(
          new DateTime(dateStart).toFormat("yyyy-MM-dd'T'HH:mm:ss")
        );

        datePath = `${new DateTime(dateStart).toFormat(
          "yyyy-MM-dd'T'HH:mm:ss"
        )}_00+00_${DateTime.now().toFormat("yyyy-MM-dd'T'HH:mm:ss")}_00+00`;
        path =
          zoneSelected && !_.isEmpty(zoneSelected)
            ? `&cluster${zoneSelected}&datetime_start=${start}`
            : `&datetime_start=${start}`;
      } else {
        if (dateEnd && DateTime.fromISO(dateEnd).isValid) {
          const end = getTimeZoneLondon(
            new DateTime(dateEnd).toFormat("yyyy-MM-dd'T'HH:mm:ss")
          );
          datePath = `${DateTime.fromISO(dateEnd)
            .minus({ days: 1 })
            .toFormat("yyyy-MM-dd'T'HH:mm:ss")}_00+00_${new DateTime(
              dateEnd
            ).toFormat("yyyy-MM-dd'T'HH:mm:ss")}_00+00`;
          path =
            zoneSelected && !_.isEmpty(zoneSelected)
              ? `&cluster${zoneSelected}&datetime_end=${end}`
              : `&datetime_end=${end}`;
        } else if (!dateStart && !dateEnd) {
          datePath = `${DateTime.now()
            .minus({ days: 1 })
            .toFormat("yyyy-MM-dd'T'HH:mm:ss")}_00+00_${DateTime.now().toFormat(
              "yyyy-MM-dd'T'HH:mm:ss"
            )}_00+00`;

          path =
            zoneSelected && !_.isEmpty(zoneSelected)
              ? `&cluster${zoneSelected}`
              : "";
        }
      }
    }

    if (path !== null) {
      datePath = _.replace(datePath, /:/g, "_");
      metric?.data?.map((item) =>
        Request.stations
          .downloadGeneric({
            metric: item.endpoint,
            timeZone: timezone,
            token: token,
            path: path,
          })
          .then((resp) => {
            setIsFirstRefresh(true);
            var zip = new JSZip();
            Object.keys(resp).map((key) => {
              switch (key) {
                case "resp_cluster":
                  zip.file(`by_cluster_avg.csv`, resp[key]);
                  break;
                case "resp_poi":
                  zip.file(`by_station_avg.csv`, resp[key]);
                  break;
                case "resp_hour":
                  zip.file(`hourly_avg.csv`, resp[key]);
                  break;
                case "resp_data":
                  zip.file(`data.csv`, resp[key]);
                  break;
                default:
                  zip.file(`${key}.csv`, resp[key]);
                  break;
              }
              return key;
            });
            // Generate the zip file asynchronously
            zip.generateAsync({ type: "blob" }).then(function (content) {
              // Force down of the Zip file
              saveAs(
                content,
                `archive${stationIdSelected ? `_${stationIdSelected}` : ""}_${item?.endpoint
                }${datePath}.zip`
              );
            });
          })
          .catch((error) => {
            onError(error);
          })
      );
    }
    // eslint-disable-next-line
  }, [
    i18n.language,
    metric,
    dateStart,
    dateEnd,
    zoneSelected,
    token,
    refresh_token,
    stationIdSelected,
  ]);

  const handleChangeZone = useCallback((item) => {
    setZoneSelected(item);
    dispatch(saveCluster(item));

    setStationIdSelected(null);
    dispatch(saveStationID(null));

    setListStationsId([]);
    setData(null);
    // eslint-disable-next-line
  }, []);

  const onLogout = useCallback((error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      dispatch(logout());
    }
    // eslint-disable-next-line
  }, []);

  const onError = useCallback(
    (error) => {
      if (isFirstRefresh) {
        setLoading(false);
        if (error?.response?.status === 403) {
          onLogout(error);
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {
              dispatch(
                refreshToken({
                  grant_type: "refresh_token",
                  refresh_token: user.refresh_token,
                })
              );
              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onLogout(error);
      }
    },
    // eslint-disable-next-line
    []
  );

  const onFailure = useCallback((error) => {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response?.data?.message
          ? error.response.data.message
          : "Errore",

        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    setDataStations(null);
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      metricStore?.name === "wind_speed,wind_dir_idx" ||
      metricStore?.name === "rain_intensity,rain_intensity_peak" ||
      metricStore?.name === "pm10,pm2_5"
    ) {
      setHasTwoMetrics(true);
    } else {
      setHasTwoMetrics(false);
    }
  }, [metricStore]);

  useEffect(() => {
    setLoading(true);
    setRefresh(false);
    Request.stations
      .allPoi({
        token: token,
      })
      .then((resp) => {
        setDataStations(resp);
        setLoading(false);
        setIsFirstRefresh(true);
      })
      .catch((error) => onError(error));
    // eslint-disable-next-line
  }, [token, isFirstRefresh, refresh]);

  useEffect(() => {
    //ottengo la lista delle stazioni associate a un determianto cluster
    if (zoneSelected && !_.isEmpty(zoneSelected)) {
      setLoading(true);
      const clustersList = [];
      dataStations?.stations?.map((item) =>
        zoneSelected.map(
          (zone) =>
            item.cluster === zone &&
            clustersList.push(
              `${item.stationId} - ${item.cluster} - ${item.address}`
            )
        )
      );
      setListStationsId(clustersList.sort());
      setLoading(false);
    } else {
      setStationIdSelected(null);
      dispatch(saveStationID(null));
    }
    // eslint-disable-next-line
  }, [zoneSelected, dataStations, refresh]);

  useEffect(() => {
    //Ottengo dalla lista delle stazioni i cluster esistenti
    if (dataStations && !_.isEmpty(dataStations?.stations)) {
      const clusters = dataStations?.stations.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.cluster === value.cluster)
      );
      const list = clusters.map((item) => {
        return item["cluster"];
      });

      setListClusters(list.sort());
    }
  }, [dataStations, refresh]);

  useEffect(() => {
    let pathTest = null;
    if (hasTwoMetrics !== null && metric) {
      setLoading(true);
      if (
        dateStart &&
        DateTime.fromISO(dateStart).isValid &&
        dateEnd &&
        DateTime.fromISO(dateEnd).isValid
      ) {
        //data di inzio e fine
        const start = getTimeZoneLondon(
          new DateTime(dateStart).toFormat("yyyy-MM-dd'T'HH:mm:ss")
        );
        const end = getTimeZoneLondon(
          new DateTime(dateEnd).toFormat("yyyy-MM-dd'T'HH:mm:ss")
        );

        pathTest =
          _.isEmpty(zoneSelected) || stationIdSelected !== null
            ? `?datetime_start=${start}&datetime_end=${end}`
            : `?cluster=${zoneSelected}&datetime_start=${start}&datetime_end=${end}`;
      } else {
        if (dateStart && DateTime.fromISO(dateStart).isValid) {
          //data di inzio e fine
          const start = getTimeZoneLondon(
            new DateTime(dateStart).toFormat("yyyy-MM-dd'T'HH:mm:ss")
          );

          pathTest =
            _.isEmpty(zoneSelected) || stationIdSelected !== null
              ? `?datetime_start=${start}`
              : `?cluster=${zoneSelected}&datetime_start=${start}`;
        } else {
          if (dateEnd && DateTime.fromISO(dateEnd).isValid) {
            const end = getTimeZoneLondon(
              new DateTime(dateEnd).toFormat("yyyy-MM-dd'T'HH:mm:ss")
            );

            pathTest =
              _.isEmpty(zoneSelected) || stationIdSelected !== null
                ? `?datetime_end=${end}`
                : `?cluster=${zoneSelected}&datetime_end=${end}`;
          } else {
            if (!dateStart && !dateEnd) {
              setLoading(true);
              pathTest =
                _.isEmpty(zoneSelected) || stationIdSelected !== null
                  ? ""
                  : `?cluster=${zoneSelected}`;
            }
          }
        }
      }

      if (pathTest !== null) {
        if (stationIdSelected) {
          metric?.data?.map((item, index) =>
            Request.stations
              .getMetricStationIdGeneric({
                station_id: _.split(stationIdSelected, "-")[0].trim(),
                metric: item?.endpoint,
                token: token,
                path: pathTest,
              })
              .then((resp) =>
                onSuccess(resp, index !== 0 ? setDataDouble : setData)
              )
              .catch((error) => onError(error))
          );
        } else {
          metric?.data?.map((item, index) =>
            Request.stations
              .getMetricGeneric({
                metric: item?.endpoint,
                token: token,
                path: pathTest,
              })
              .then((resp) =>
                onSuccess(resp, index !== 0 ? setDataDouble : setData)
              )
              .catch((error) => onError(error))
          );
        }
      }
    }
    // eslint-disable-next-line
  }, [
    hasTwoMetrics,
    refresh,
    metric,
    dateStart,
    dateEnd,
    stationIdSelected,
    zoneSelected,
    valueData,
    token,
  ]);

  useEffect(() => {
    if (
      data &&
      (data?.avg?.data === null ||
        _.isEmpty(data?.avg?.data?.filter((item) => item !== null))) &&
      (data?.avg?.data_min === null ||
        _.isEmpty(data?.avg?.data_min?.filter((item) => item !== null))) &&
      (data?.avg?.data_max === null ||
        _.isEmpty(data?.avg?.data_max?.filter((item) => item !== null))) &&
      data?.avg?.min === null &&
      data?.avg?.max === null &&
      data?.avg?.mean === null &&
      (data?.by_cluster?.data === null ||
        _.isEmpty(data?.by_cluster?.data?.filter((item) => item !== null))) &&
      (data?.by_station === null ||
        _.isEmpty(data?.by_station) ||
        _.isEmpty(data?.by_station.filter((item) => item.data !== null))) &&
      (data?.hourly?.data === null ||
        _.isEmpty(data?.hourly?.data?.filter((item) => item !== null))) &&
      // data?.hourly.hour === null &&
      //  data.time === null &&
      (dataDouble === null ||
        ((dataDouble?.avg?.data === null ||
          _.isEmpty(dataDouble?.avg?.data?.filter((item) => item !== null))) &&
          dataDouble?.avg?.min === null &&
          dataDouble?.avg?.max === null &&
          dataDouble?.avg?.mean === null &&
          (dataDouble?.by_cluster?.data === null ||
            _.isEmpty(
              dataDouble?.by_cluster?.data?.filter((item) => item !== null)
            )) &&
          (dataDouble?.by_station === null ||
            _.isEmpty(dataDouble?.by_station) ||
            _.isEmpty(
              dataDouble?.by_station?.filter((item) => item.data !== null)
            )) &&
          (dataDouble?.hourly?.data === null ||
            _.isEmpty(
              dataDouble?.hourly?.data?.filter((item) => item !== null)
            ))))
    ) {
      setError("No dati");
    } else {
      setError(null);
    }
  }, [refresh, data, dataDouble, zoneSelected, stationID]);

  useEffect(() => {
    if (valueData === '24h') {
      setViewBarChart(true);
    } else {
      if (
        dateStart &&
        DateTime.fromISO(dateStart).isValid &&
        dateEnd &&
        DateTime.fromISO(dateEnd).isValid
      ) {
        const start = new DateTime(dateStart);
        const end = new DateTime(dateEnd);
        const diff = end.diff(start, ["months"]);
        if (diff?.months >= 1) {
          setViewBarChart(false);
        } else {
          setViewBarChart(true);
        }
      } else {
        if (
          dateStart &&
          DateTime.fromISO(dateStart).isValid) {
          const start = new DateTime(dateStart);
          const end = DateTime.now();
          const diff = end.diff(start, ["months"]);
          if (diff?.months >= 1) {
            setViewBarChart(false);
          } else {
            setViewBarChart(true);
          }
        }
      }
    }
  }, [dateStart, dateEnd, valueData]);

  return (
    <Fragment>
      <Fragment>
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Grid
            item
            container
            xs={12}
            spacing={2}
            sx={{ display: "flex", alignItems: "end" }}
          >
            <Grid item xs={12}>
              <SelectZoneAndStationCard
                hasRefresh={true}
                onRefresh={onRefresh}
                listClusters={listClusters}
                handleChangeZone={handleChangeZone}
                listStationsId={listStationsId}
                loading={loading}
                zoneSelected={zoneSelected}
                stationIdSelected={stationIdSelected}
                handleChangeStationIdSelected={handleChangeStationIdSelected}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={5} lg={6}>
              <CardAutocompleteComponent
                options={optionsMetrics}
                metric={metric}
                handleChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={7} lg={6}>
              <CurrentMetricDataContainer
                metric={metric?.data}
                zoneSelected={zoneSelected}
                stationIdSelected={_.split(stationIdSelected, "-")[0].trim()}
                refresh={refresh}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {stationIdSelected === null && zoneSelected?.length >= 2 && (
              <TitleSectionComponent
                title={t("Stats not available with 2 or more zones selected and no station")}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <StatsMetricContainer
              refresh={refresh}
              metric={metric}
              zoneSelected={zoneSelected}
              stationIdSelected={stationIdSelected}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectDateStartAndEndComponent
              onChangeValueDate={onChangeValueDate}
              onChangeDateStart={onChangeDateStart}
              onChangeDateEnd={onChangeDateEnd}
              valueData={valueData}
              dateStart={dateStart}
              dateEnd={dateEnd}
              download={true}
              onDownload={onDownload}
              onRefresh={onRefresh}
            />
          </Grid>

          {loading ? (
            <Grid item xs={12}>
              <Loading />
            </Grid>
          ) : error ? (
            <Grid item xs={12}>
              <ErrorCardcomponent message={t("No data for selected filters")} />
            </Grid>
          ) : (
            <Grid item xs={12} sx={{ minHeight: 300 }}>
              <MetricRenderContainer
                metric={metric}
                viewHorChart={stationIdSelected === null}
                viewBarChart={viewBarChart}
                data={data}
                dataDouble={dataDouble}
                dataStations={dataStations}
              />
            </Grid>
          )}
        </Grid>
      </Fragment>
    </Fragment>
  );
};

export default MetricsEnvironmentContainer;
